import AgentRouteMap from "./AgentRouteMap";
import moment from "moment/moment";

const RouteModal = ({ show, onClose, session, locations, visits, selfies }) => {
  if (!show) return null;
  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.5)",
      }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          {/* Header */}

          <div className="modal-header p-4">
            <div>
              <h6 className="fw-bold">Agent Route</h6>
            </div>

             <button className="btn-close-route btn-sm" onClick={onClose}>
              <i aria-hidden="true" className="ki ki-close text-dark font-size-xs"></i>
            </button>
          </div>

          {/* Summary */}
          <div className="modal-body p-4">
            <div className="row mb-3">
              <div className="col-md-3">
                <small className="text-muted">Check In</small>

                <h6>
                  {session?.checkInTime
                    ? moment.utc(session?.checkInTime).local().format("hh:mm A")
                    : "-"}
                </h6>
              </div>

              <div className="col-md-3">
                <small className="text-muted">Check Out</small>
                <h6>
                  {session?.checkOutTime
                    ? moment.utc(session.checkOutTime).local().format("hh:mm A")
                    : "Working..."}
                </h6>
              </div>

              <div className="col-md-3">
                <small className="text-muted">Distance</small>

                <h6>{session?.distanceKm ?? 0} KM</h6>
              </div>

              <div className="col-md-3">
                <small className="text-muted">Duration</small>

                <h6>
                  {session?.durationMinutes
                    ? session.durationMinutes >= 60
                      ? `${Math.floor(session.durationMinutes / 60)}h ${
                          session.durationMinutes % 60
                        }m`
                      : `${session.durationMinutes}m`
                    : "0m"}
                </h6>
              </div>
            </div>

            {/* Map */}
            <AgentRouteMap locations={locations} visits={visits} session={session} />
          </div>

          {/* <div className="modal-footer p-2">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default RouteModal;
